import { render } from "./RequestItem.vue?vue&type=template&id=b828ae6a&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=b828ae6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b828ae6a"

export default script